"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Container = styled_1.default.div(({ circular }) => ({
    borderRadius: circular ? '50%' : 3,
    overflow: 'hidden',
}));
const Img = styled_1.default.img({
    borderRadius: 3,
    width: '100%',
    verticalAlign: 'middle',
});
function Image({ circular, className, src, alt }) {
    return (react_1.default.createElement(Container, { circular: circular, className: className },
        react_1.default.createElement(Img, { src: src, alt: alt })));
}
exports.default = Image;
